import ArrayUtils from '../utils/ArrayUtils'
import i18n from '../i18n'

const PeriodListEnum = Object.freeze({
  '0': i18n.t('AllPeriod'),
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  '10': '10',
  '11': '11',
  '12': '12',
})

const getArray = function () {
  return ArrayUtils.EnumToArray(PeriodListEnum)
}
export default { PeriodListEnum, getArray };